import _ from 'lodash';
import { AUTH_USER, DEAUTH_USER, CLOSE_INACTIVITY_ALERT } from '../constants/actions';
import { logout } from '../actions/auth';
import { openInactivityAlert } from '../actions/ui';
import { TIMEOUT_DURATION } from '../constants/general';
import isLoadedFromMobile from '../helpers/platform';

let reduxStore = null;
let theLastActivityTimestamp = new Date().getTime();
let inactivityTimeout = TIMEOUT_DURATION;
let inactivityCheckStarted = false;

function setLastActivityTimeStamp() {
  // Disable inactivity features for mobile
  if (isLoadedFromMobile()) {
    return;
  }
  theLastActivityTimestamp = new Date().getTime();
}
document.addEventListener('click', setLastActivityTimeStamp);
document.addEventListener('keypress', setLastActivityTimeStamp);

function inactivityLogout() {
  if (!inactivityCheckStarted) {
    reduxStore.dispatch(logout());
  }
}

setInterval(() => {
  // Disable inactivity features for mobile
  if (isLoadedFromMobile()) {
    return;
  }

  if (inactivityCheckStarted) {
    const now = new Date().getTime();

    // Open inactivity alert
    // inactivityTimeout is stored in seconds - need to convert to milliseconds
    if (now - theLastActivityTimestamp > inactivityTimeout * 1000) {
      inactivityCheckStarted = false;
      reduxStore.dispatch(openInactivityAlert());
      setTimeout(inactivityLogout, 11000);
    }
  }
}, 1000);

export default (store) => {
  reduxStore = store;
  return (next) => (action) => {
    if (!action) return;

    // Disable inactivity features for mobile
    if (isLoadedFromMobile()) {
      next(action);
      return;
    }

    switch (action.type) {
      case AUTH_USER: {
        inactivityTimeout = _.get(action, 'payload.inactivityTimeout', inactivityTimeout);
        inactivityCheckStarted = true;
        break;
      }
      case DEAUTH_USER: {
        inactivityCheckStarted = false;
        break;
      }
      case CLOSE_INACTIVITY_ALERT: {
        if (!action.payload.shouldLogout) {
          inactivityCheckStarted = true;
        } else {
          inactivityCheckStarted = false;
          inactivityLogout();
        }
        break;
      }
      default:
        break;
    }
    next(action);
  };
};
